(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["ReactRouterMagic"] = factory(require("react"), require("prop-types"));
	else
		root["ReactRouterMagic"] = factory(root["React"], root["PropTypes"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 16);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isFunction = __webpack_require__(8);
var isString = __webpack_require__(15);
function execValOrFunc(valOrFunc, location, parentMatch) {
    if (isFunction(valOrFunc)) {
        return valOrFunc(location, parentMatch);
    }
    return valOrFunc;
}
exports.execValOrFunc = execValOrFunc;
function checkSwitchState(props, parentRouterState, match) {
    if (parentRouterState.switch === false && props.switchIndex !== undefined) {
        console.warn("You should not set switchIndex props yourself");
    }
    if (parentRouterState.switch && props.switchIndex === undefined) {
        console.warn("Error: Switch children are supposed to have switchIndex passed from parent");
    }
    // in a switch but there are no match
    if (parentRouterState.switch &&
        parentRouterState.switch.matchIndex === false) {
        return false;
    }
    // in a switch but switchIndex does not match
    if (parentRouterState.switch &&
        props.switchIndex !== undefined &&
        parentRouterState.switch.matchIndex !== props.switchIndex) {
        return false;
    }
    // ok match !
    return match;
}
exports.checkSwitchState = checkSwitchState;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
exports.isModifiedEvent = isModifiedEvent;
function createNavParams(to, history, location, replace, match, parentMatch) {
    if (replace === void 0) { replace = false; }
    var doMatch = match ? execValOrFunc(match, location, parentMatch) : null;
    var toLocation = execTo(to, doMatch, location, parentMatch);
    var href = history.createHref(toLocation);
    var doNavigate = function () { return navigate(toLocation, history, replace); };
    var params = {
        href: href,
        navigate: doNavigate,
        match: doMatch,
        location: location,
        handleAnchorClick: createHandleAnchorClick(doNavigate),
    };
    return params;
}
exports.createNavParams = createNavParams;
function createHandleAnchorClick(navigate) {
    return function (event, target) {
        if (!event.defaultPrevented &&
            event.button === 0 &&
            !target &&
            !isModifiedEvent(event) // ignore clicks with modifier keys
        ) {
            event.preventDefault();
            navigate();
        }
    };
}
exports.createHandleAnchorClick = createHandleAnchorClick;
function navigate(to, history, replace) {
    if (replace === void 0) { replace = false; }
    if (replace) {
        history.replace(to);
    }
    else {
        history.push(to);
    }
}
exports.navigate = navigate;
function execTo(to, match, location, parentMatch) {
    var toExecuted = isFunction(to) ? (to(match, location, parentMatch)) : to;
    return isString(toExecuted) ? { pathname: toExecuted } : toExecuted;
}
exports.execTo = execTo;
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true,
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true,
};
function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') {
        var keys = Object.getOwnPropertyNames(sourceComponent);
        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                }
                catch (error) {
                    console.warn(error);
                }
            }
        }
    }
    return targetComponent;
}
exports.hoistNonReactStatics = hoistNonReactStatics;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store = (function () {
    function Store(initialState) {
        this.listeners = [];
        this.state = initialState;
        this.subscribe = this.subscribe.bind(this);
    }
    Store.prototype.setState = function (newState) {
        this.state = newState;
        this.broadcast(this.state);
        return this;
    };
    Store.prototype.broadcast = function (state) {
        this.listeners.forEach(function (listener) { return listener(state); });
    };
    Store.prototype.getState = function () {
        return this.state;
    };
    Store.prototype.subscribe = function (listener) {
        var _this = this;
        this.listeners.push(listener);
        return function () {
            var index = _this.listeners.indexOf(listener);
            if (index > -1) {
                _this.listeners.splice(index, 1);
            }
        };
    };
    return Store;
}());
exports.Store = Store;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(14);
var isArguments = __webpack_require__(13);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var Store_1 = __webpack_require__(2);
var PropTypes = __webpack_require__(3);
var utils_1 = __webpack_require__(1);
var NavProvider = (function (_super) {
    __extends(NavProvider, _super);
    function NavProvider(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.isUnmounted = false;
        if (!context.routerStore || !context.routerStore.getState() || !context.router || !context.router.history) {
            throw new Error('InjectMatch need a RouterProvider as ancestor');
        }
        return _this;
    }
    NavProvider.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.noSubscribe !== true) {
            this.unsubscribe = this.context.routerStore.subscribe(function () {
                _this.update();
            });
        }
    };
    NavProvider.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (this.props.noSubscribe !== nextProps.noSubscribe) {
            if (nextProps.noSubscribe && this.unsubscribe) {
                this.unsubscribe();
            }
            else {
                this.unsubscribe = this.context.routerStore.subscribe(function () {
                    _this.update();
                });
            }
        }
    };
    NavProvider.prototype.componentWillUnmount = function () {
        this.isUnmounted = true;
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    };
    NavProvider.prototype.render = function () {
        var _a = this.props, renderChild = _a.renderChild, to = _a.to, replace = _a.replace, match = _a.match;
        var parentRouterState = this.context.routerStore.getState();
        var childParams = utils_1.createNavParams(to, this.context.router.history, parentRouterState.location, replace, match, parentRouterState.match);
        return renderChild(childParams);
    };
    NavProvider.prototype.update = function () {
        if (this.isUnmounted === false) {
            this.forceUpdate();
        }
    };
    return NavProvider;
}(react_1.Component));
NavProvider.displayName = 'NavProvider';
NavProvider.contextTypes = {
    routerStore: PropTypes.instanceOf(Store_1.Store),
    router: PropTypes.any,
};
exports.NavProvider = NavProvider;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var PropTypes = __webpack_require__(3);
var Store_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(1);
var Redirect = (function (_super) {
    __extends(Redirect, _super);
    function Redirect(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.unsubscribe = context.routerStore.subscribe(function () {
            _this.update(_this.props);
        });
        return _this;
    }
    Redirect.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.noSubscribe !== true) {
            this.unsubscribe = this.context.routerStore.subscribe(function () {
                _this.update(_this.props);
            });
        }
        this.update(this.props);
    };
    Redirect.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.update(nextProps);
    };
    Redirect.prototype.render = function () {
        return null;
    };
    Redirect.prototype.componentWillUnmount = function () {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    };
    Redirect.prototype.update = function (props) {
        var parentRouterState = this.context.routerStore.getState();
        var match = utils_1.checkSwitchState(props, parentRouterState, utils_1.execValOrFunc(this.props.match, parentRouterState.location, parentRouterState.match));
        var push = this.props.push === true;
        if (match !== false) {
            var toLocation = utils_1.execTo(this.props.to, match, parentRouterState.location, parentRouterState.match);
            utils_1.navigate(toLocation, this.context.router.history, !push);
        }
    };
    return Redirect;
}(react_1.Component));
Redirect.displayName = 'Redirect';
Redirect.contextTypes = {
    routerStore: PropTypes.instanceOf(Store_1.Store),
    router: PropTypes.any,
};
exports.Redirect = Redirect;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(3);
var isFunction = __webpack_require__(8);
var isEqual = __webpack_require__(4);
var react_1 = __webpack_require__(0);
var Store_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(1);
var Route = (function (_super) {
    __extends(Route, _super);
    function Route(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.matchResult = null;
        _this.isUnmounted = false;
        if (!context.routerStore || !context.routerStore.getState()) {
            throw new Error('Route need a RouterProvider as ancestor');
        }
        var parentRouterState = context.routerStore.getState();
        _this.matchResult = utils_1.execValOrFunc(props.match, parentRouterState.location, parentRouterState.match);
        if (props.passif !== true) {
            _this.unsubscribe = context.routerStore.subscribe(function () {
                _this.update(_this.props);
            });
        }
        _this.update(_this.props, false);
        return _this;
    }
    Route.prototype.getChildContext = function () {
        return {
            routerStore: this.routerStore,
        };
    };
    Route.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.update(nextProps, false);
    };
    Route.prototype.componentWillUnmount = function () {
        this.isUnmounted = true;
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    };
    Route.prototype.render = function () {
        var _a = this.props, component = _a.component, render = _a.render, children = _a.children;
        var childParams = {
            match: this.matchResult,
            location: this.context.routerStore.getState().location,
        };
        if (component) {
            return (this.matchResult !== false) ? React.createElement(component, childParams) : null;
        }
        if (render) {
            return (this.matchResult !== false) ? render(childParams) : null;
        }
        // then children (even if not match)
        if (isFunction(children)) {
            return children(childParams);
        }
        if (children) {
            return React.Children.only(children);
        }
        return null;
    };
    Route.prototype.update = function (props, forceUpdate) {
        if (forceUpdate === void 0) { forceUpdate = true; }
        var parentRouterState = this.context.routerStore.getState();
        this.matchResult = utils_1.execValOrFunc(props.match, parentRouterState.location, parentRouterState.match);
        this.matchResult = utils_1.checkSwitchState(props, parentRouterState, this.matchResult);
        var newState = {
            location: parentRouterState.location,
            match: this.matchResult,
            switch: false,
        };
        if (!this.routerStore) {
            this.routerStore = new Store_1.Store(newState);
            if (forceUpdate && !this.isUnmounted) {
                this.forceUpdate();
            }
        }
        else {
            if (!isEqual(this.routerStore.getState(), newState)) {
                this.routerStore.setState(newState);
                if (forceUpdate && !this.isUnmounted) {
                    this.forceUpdate();
                }
            }
        }
    };
    return Route;
}(react_1.Component));
Route.displayName = 'Route';
Route.childContextTypes = {
    routerStore: PropTypes.instanceOf(Store_1.Store),
};
Route.contextTypes = {
    routerStore: PropTypes.instanceOf(Store_1.Store),
};
exports.Route = Route;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array constructors, and
  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isFunction;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_1 = __webpack_require__(0);
var PropTypes = __webpack_require__(3);
var Store_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(1);
/**
 * Render the first Route that match
 */
function InjectMagicRouter(options) {
    if (options === void 0) { options = {}; }
    return function (Target) {
        var _a = options["match"], injectMatch = _a === void 0 ? true : _a, _b = options["location"], injectLocation = _b === void 0 ? true : _b, _c = options["history"], injectHistory = _c === void 0 ? true : _c;
        if (!injectMatch && !injectLocation && !injectHistory) {
            console.warn("All inject are off, just returning the component");
            return Target;
        }
        // if we inject only history, no need to subscribe
        var needSubscribe = !injectMatch && !injectLocation && injectHistory;
        var MagicRouterProvider = (function (_super) {
            __extends(MagicRouterProvider, _super);
            function MagicRouterProvider(props, context) {
                var _this = _super.call(this, props, context) || this;
                _this.isUnmounted = false;
                if (!context.routerStore || !context.routerStore.getState() || !context.router || !context.router.history) {
                    throw new Error('InjectMatch need a RouterProvider as ancestor');
                }
                if (needSubscribe) {
                    _this.unsubscribe = context.routerStore.subscribe(function () {
                        if (_this.isUnmounted === false) {
                            _this.forceUpdate();
                        }
                    });
                }
                return _this;
            }
            MagicRouterProvider.prototype.componentWillUnmount = function () {
                this.isUnmounted = true;
                if (this.unsubscribe) {
                    this.unsubscribe();
                }
            };
            MagicRouterProvider.prototype.render = function () {
                var injectedProps = {};
                if (injectMatch) {
                    injectedProps.match = this.context.routerStore.getState().match;
                }
                if (injectHistory) {
                    injectedProps.history = this.context.router.history;
                }
                if (injectLocation) {
                    injectedProps.location = this.context.routerStore.getState().location;
                }
                return React.createElement(Target, __assign({}, injectedProps, this.props));
            };
            return MagicRouterProvider;
        }(react_1.Component));
        MagicRouterProvider.displayName = 'MagicRouterProvider';
        MagicRouterProvider.contextTypes = {
            routerStore: PropTypes.instanceOf(Store_1.Store),
            router: PropTypes.any,
        };
        return utils_1.hoistNonReactStatics(MagicRouterProvider, Target);
    };
}
exports.InjectMagicRouter = InjectMagicRouter;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var NavProvider_1 = __webpack_require__(5);
exports.Link = function (props) {
    var to = props.to, match = props.match, noSubscribe = props.noSubscribe, replace = props.replace, _a = props.activeClassName, activeClassName = _a === void 0 ? '' : _a, className = props.className, aProps = __rest(props, ["to", "match", "noSubscribe", "replace", "activeClassName", "className"]);
    return (React.createElement(NavProvider_1.NavProvider, __assign({}, { to: to, match: match, noSubscribe: noSubscribe, replace: replace }, { renderChild: function (params) { return (React.createElement("a", __assign({}, aProps, { href: params.href, className: [(params.match !== false ? activeClassName : ''), className].join(' '), onClick: function (e) {
                if (aProps.onClick) {
                    aProps.onClick(e);
                }
                return params.handleAnchorClick(e);
            } }))); } })));
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(3);
var isEqual = __webpack_require__(4);
var react_1 = __webpack_require__(0);
var Store_1 = __webpack_require__(2);
var RouterProvider = (function (_super) {
    __extends(RouterProvider, _super);
    function RouterProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.routerStore = new Store_1.Store({
            location: props.location,
            match: null,
            switch: false,
        });
        return _this;
    }
    RouterProvider.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (!isEqual(nextProps.location, this.props.location)) {
            this.routerStore.setState({
                location: nextProps.location,
                match: null,
                switch: false,
            });
        }
    };
    RouterProvider.prototype.getChildContext = function () {
        return {
            router: { history: this.props.history },
            routerStore: this.routerStore,
        };
    };
    RouterProvider.prototype.render = function () {
        return React.Children.only(this.props.children);
    };
    return RouterProvider;
}(react_1.Component));
RouterProvider.displayName = 'RouterProvider';
RouterProvider.childContextTypes = {
    routerStore: PropTypes.instanceOf(Store_1.Store),
    router: PropTypes.any,
};
exports.RouterProvider = RouterProvider;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_1 = __webpack_require__(0);
var PropTypes = __webpack_require__(3);
var Store_1 = __webpack_require__(2);
var Route_1 = __webpack_require__(7);
var Redirect_1 = __webpack_require__(6);
var utils_1 = __webpack_require__(1);
var isEqual = __webpack_require__(4);
function isComponentType(child, type) {
    return child.type === type;
}
/**
 * Render the first Route that match
 * To do so, Switch take the passed children and test their match props
 * It find the first match and pass in a swtichIndex in context
 */
var Switch = (function (_super) {
    __extends(Switch, _super);
    function Switch(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.validChildren = [];
        _this.isUnmounted = false;
        if (!context.routerStore || !context.routerStore.getState()) {
            throw new Error('Switch need a RouterProvider as ancestor');
        }
        _this.unsubscribe = context.routerStore.subscribe(function () {
            _this.update(_this.props);
        });
        _this.update(props, false);
        return _this;
    }
    Switch.prototype.getChildContext = function () {
        return {
            routerStore: this.routerStore,
        };
    };
    Switch.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.update(nextProps, false);
    };
    Switch.prototype.componentWillUnmount = function () {
        this.isUnmounted = true;
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    };
    Switch.prototype.render = function () {
        var _a = this.props.renderContainer, renderContainer = _a === void 0 ? this.defaultRenderContainer : _a;
        var childrenWithIndex = this.validChildren.map(function (child, index) { return (React.cloneElement(child, { switchIndex: index })); });
        return renderContainer(childrenWithIndex);
    };
    Switch.prototype.defaultRenderContainer = function (children) {
        return (React.createElement("div", null, React.Children.toArray(children)));
    };
    Switch.prototype.updateValidChildren = function (props) {
        var _this = this;
        this.validChildren = [];
        React.Children.forEach(props.children, function (child) {
            if (!React.isValidElement(child)) {
                return;
            }
            if (isComponentType(child, Route_1.Route) ||
                isComponentType(child, Redirect_1.Redirect)) {
                _this.validChildren.push(child);
            }
            else {
                console.warn("Switch only accept Route or Redirect components as children");
            }
        });
    };
    Switch.prototype.update = function (props, forceUpdate) {
        if (forceUpdate === void 0) { forceUpdate = true; }
        this.updateValidChildren(props);
        var parentRouterState = this.context.routerStore.getState();
        var match = null;
        var matchIndex = false;
        this.validChildren.forEach(function (child, index) {
            if (matchIndex !== false) {
                return;
            }
            var tmpMatch = utils_1.execValOrFunc(child.props.match, parentRouterState.location, parentRouterState.match);
            if (tmpMatch !== false) {
                match = tmpMatch;
                matchIndex = index;
            }
        });
        var newState = {
            location: parentRouterState.location,
            match: parentRouterState.match,
            switch: { match: match, matchIndex: matchIndex },
        };
        if (!this.routerStore) {
            this.routerStore = new Store_1.Store(newState);
            if (forceUpdate && !this.isUnmounted) {
                this.forceUpdate();
            }
        }
        else {
            if (!isEqual(this.routerStore.getState(), newState)) {
                this.routerStore.setState(newState);
                if (forceUpdate && !this.isUnmounted) {
                    this.forceUpdate();
                }
            }
        }
    };
    return Switch;
}(react_1.Component));
Switch.displayName = 'Switch';
Switch.childContextTypes = {
    routerStore: PropTypes.instanceOf(Store_1.Store),
};
Switch.contextTypes = {
    routerStore: PropTypes.instanceOf(Store_1.Store),
};
exports.Switch = Switch;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 15 */
/***/ (function(module, exports) {

/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(7));
__export(__webpack_require__(12));
__export(__webpack_require__(5));
__export(__webpack_require__(11));
__export(__webpack_require__(6));
__export(__webpack_require__(10));
__export(__webpack_require__(9));
var utils_1 = __webpack_require__(1);
exports.createNavParams = utils_1.createNavParams;
exports.createHandleAnchorClick = utils_1.createHandleAnchorClick;
exports.navigate = utils_1.navigate;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js